<div class="design-and-amount-header-container">
    <mat-card-title>Select a Design</mat-card-title>
</div>
<div
    class="design-previews"
    skeletonData
    [showSkeleton]="!designs"
    [placeholderWidth]="'100%'"
>
    <mat-button-toggle-group
        formControlName="itemImagePath"
        [ngClass]="{
            'invalid-toggle-group':
                selectedGiftCardDesignID.touched &&
                selectedGiftCardDesignID.invalid
        }"
    >
        <ng-container *ngFor="let giftCardDesign of getFeaturedDesigns()">
            <mat-button-toggle
                (click)="designSelected(giftCardDesign)"
                [value]="giftCardDesign.image"
                skeletonData
                [showSkeleton]="
                    !isSelectableDesignImageReady(giftCardDesign.id)
                "
                [placeholderHeight]="'100%'"
                [placeholderWidth]="'100%'"
            >
                <img
                    [src]="giftCardDesign.image"
                    (load)="selectableDesignImageIsReady(giftCardDesign.id)"
                    qa="gift-card-design"
                />
                <div
                    class="selected-design"
                    *ngIf="selectedGiftCardDesignID.value == giftCardDesign.id"
                >
                    <mat-icon
                        class="mat-icon-check"
                        aria-hidden="false"
                        aria-label="Selected design"
                    >
                        done</mat-icon
                    >
                </div>
            </mat-button-toggle>
        </ng-container>
    </mat-button-toggle-group>
    <button
        type="button"
        mat-stroked-button
        color="primary"
        class="more-designs-button ols-mat-stroked-button-color"
        (click)="openMoreDesignsModal()"
        qa="more-designs-button"
    >
        See More
    </button>
</div>
<mat-error
    *ngIf="
        selectedGiftCardDesignID.touched &&
        selectedGiftCardDesignID.errors?.required
    "
>
    Design required
</mat-error>
